module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-remote-2.deb01e49.webp";